import { DeclarationDrBase } from './declaration-dr.base.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class DeclarationDpNego extends DeclarationDrBase {
    static jsonMap = {
        ...DeclarationDrBase.jsonMap,
        s_recolte: { key: 's_recolte' },
        qte_ach_r: { key: 'qte_ach_r' },
        vol_issu_r: { key: 'vol_issu_r' },
        vol_ach_m: { key: 'vol_ach_m' },
        vol_issu_m: { key: 'vol_issu_m' },
        fournisseur: { key: 'evv_fournisseur', optional: true, default: '' },
        details: { key: 'list', converter: new (ArrayClassConverterFactory.build(DeclarationDpNego))(), optional: true, default: () => [] }
    };

    s_recolte: number;
    qte_ach_r: number;
    vol_issu_r: number;
    vol_ach_m: number;
    vol_issu_m: number;
    fournisseur: string;
    details: DeclarationDpNego[];
}
